module.exports = __webpack_public_path__ + "img/payment_spe.e1c719ce.png";